import { type PermissionLevelOption } from '../models/space.model';

/** Available permission level options for dropdown. */
export const PERMISSION_OPTIONS: PermissionLevelOption[] = [
  { value: 'full_access', label: 'Full Access' },
  { value: 'can_edit', label: 'Can Edit' },
  { value: 'can_comment', label: 'Can Comment' },
  { value: 'can_view', label: 'Can View' },
];
